<template>
  <div class="row" v-if="state.perguntas.length > 0">
    <div class="col-12">
      <div class="card border-radius-top-end-0 border-radius-top-start-0 border-top-end-radius-0 anamnese-card">
        <div class="card-body">
          <template v-for="(item, idx) in state.perguntas" :key="item.id">
            <div class="anamnese-question-block" :class="{ 'anamnese-alt': idx % 2 === 1 }">
              <div class="anamnese-question-label">
                <span class="anamnese-question-number">{{ idx + 1 }}</span>
                {{ item.question }}
              </div>
              <div class="anamnese-answer-area">
                  <textarea
                      v-if="item.type == 'textarea'"
                      class="form-control anamnese-textarea"
                      rows="4"
                      v-model="state.respostas[item.id]['answer']"
                  ></textarea>

                <input
                    v-if="item.type == 'text'"
                    type="text"
                    class="form-control anamnese-input"
                    v-model="state.respostas[item.id]['answer']"
                />

                <template v-if="item.type == 'checkbox'">
                  <div class="anamnese-options-grid">
                    <div
                        class="anamnese-option-item pointer"
                        v-for="option in item.options"
                        :key="option.id"
                        :class="{ 'anamnese-option-checked': state.respostas[item.id]['checkbox'][option.id]['checked'] }"
                        @click="state.respostas[item.id]['checkbox'][option.id]['checked'] = !state.respostas[item.id]['checkbox'][option.id]['checked']"
                    >
                      <input
                          class="mt-1 form-check-input anamnese-check"
                          type="checkbox"
                          value="1"
                          v-model="state.respostas[item.id]['checkbox'][option.id]['checked']"
                      />
                      <span class="ms-2 anamnese-option-text">
                          {{ option.option }}
                        </span>
                    </div>
                  </div>
                </template>

                <template v-if="item.type == 'radio'">
                  <div class="anamnese-options-grid">
                    <div
                        class="anamnese-option-item pointer"
                        v-for="option in item.options"
                        :key="option.id"
                        :class="{ 'anamnese-option-checked': state.respostas[item.id]['anamnese_question_option_id'] == option.id }"
                        @click="state.respostas[item.id]['anamnese_question_option_id'] = option.id, state.respostas[item.id]['answer'] = option.option"
                    >
                      <input
                          class="form-check-input anamnese-check"
                          type="radio"
                          name="flexRadioDefault"
                          :checked="state.respostas[item.id]['anamnese_question_option_id'] == option.id"
                      />
                      <label class="form-check-label ms-2 anamnese-option-text" for="flexRadioDefault2">
                        {{ option.option }}
                      </label>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div class="row mt-4">
            <div class="col-12 text-end">
              <router-link to="/avaliacao-fisica">
                <button type="button" class="btn bg-gradient-secondary">{{$t('back')}}</button>
              </router-link>
              <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
                {{$t('save')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { reactive, onMounted, ref, inject } from "vue";
  import { useI18n } from 'vue-i18n';
	import { useStore } from "vuex";
	import anamneseRepository from "@/services/api/anamneseRepository";
	import MyTable from "../../../../../components/MyTable.vue";
	import { useRouter } from "vue-router";

	export default {
		components: {
			MyTable,
		},
    props: {
      avaliacaoIdProp: {
        type: Number,
        default: 0
      },
      anamneseProp: {
        type: Array,
        required: true,
      }
    },
    setup(props, context) {
      const { t } = useI18n();
			const router = useRouter();
			const swal = inject("$swal");
			const store = useStore();
			onMounted(() => {
        console.log(props.anamneseProp)
				store.commit("SET_SPLASH_SCREEN", false);
        if(props.anamneseProp !== null) {
          state.anamneseRespostas = props.anamneseProp
        }
				listarPerguntas()
				//listarPlanosTreino()

        state.avaliacaoId = props.avaliacaoIdProp
			});

			// const hidePassword = ref(true)
			// const passwordFieldIcon = computed(() => hidePassword.value ? ['fa', 'eye'] : ['fa', 'eye-slash']);
			// const passwordFieldType = computed(() => hidePassword.value ? "password" : "text");

			const state = reactive({
				perguntas: [],
				respostas: [],
				trainingPlanid: '',
        avaliacaoId: 0,
        anamneseRespostas: []
			})

			/*const listarPerguntas = () => {
				store.commit("SET_SPLASH_SCREEN", true);
				anamneseRepository.AnamnesePerguntasGet().then((response) => {
					store.commit("SET_SPLASH_SCREEN", false);
					state.perguntas = []
					if (response.data.success) {
						let training_plan_id = store.getters.TrainingPlanManager
						// let studentId = store.getters.StudentManager
						response.data.data.forEach(item => {
							let obj = []
							obj['anamnese_question_id'] = item.id
							obj['anamnese_question_option_id'] = null
							obj['checkbox'] = []
							obj['answer'] = null
							obj['observation'] = null
							obj['training_plan_id'] = training_plan_id

							if(item.type === 'checkbox') {
								item.options.forEach(opt => {
									obj['checkbox'][opt.id] = {name: opt.option, checked: false}
								})
							}

							state.respostas[item.id] = obj
							//state.respostas.push(obj)
						})
						state.perguntas = response.data.data
					}
				})
				.catch((error) => {
					store.commit("SET_SPLASH_SCREEN", false);
					swal({
						icon: "error",
						title: "Erro ao elaborar anamnese!",
						text: error.message,
					});
				});
			}*/
      const listarPerguntas = () => {
        store.commit("SET_SPLASH_SCREEN", true);
        anamneseRepository.AnamnesePerguntasGet().then((response) => {
          store.commit("SET_SPLASH_SCREEN", false);
          state.perguntas = []

          if (response.data.success) {
            let training_plan_id = store.getters.TrainingPlanManager;

            response.data.data.forEach(item => {
              let obj = {
                anamnese_question_id: item.id,
                anamnese_question_option_id: null,
                checkbox: [],
                answer: null,
                observation: null,
                training_plan_id: training_plan_id
              };

              if (item.type === 'checkbox') {
                item.options.forEach(opt => {
                  obj['checkbox'][opt.id] = { name: opt.option, checked: false };
                });
              }

              state.respostas[item.id] = obj;
            });

            state.perguntas = response.data.data;

            // Se tiver avaliação, buscar respostas preenchidas
            if (state.avaliacaoId > 0) {
              preencherRespostas(state.anamneseRespostas);
              /*anamneseRepository.AnamneseRespostasGet(state.avaliacaoId).then(resp => {
                if (resp.data.success) {
                  preencherRespostas(resp.data.data);
                }
              });*/
            }
          }
        }).catch((error) => {
          store.commit("SET_SPLASH_SCREEN", false);
          swal({
            icon: "error",
            title: "Erro ao elaborar anamnese!",
            text: error.message,
          });
        });
      };

      const preencherRespostas = (respostasAPI) => {
        respostasAPI.forEach(resp => {
          const perguntaId = resp.anamnese_question_id;
          const pergunta = state.perguntas.find(p => p.id === perguntaId);

          if (!pergunta) return;

          if (pergunta.type === 'checkbox') {
            // A resposta vem em uma string separada por vírgulas
            const respostasMarcadas = (resp.answer || '').split(',').map(r => r.trim());

            respostasMarcadas.forEach(nome => {
              const option = pergunta.options.find(o => o.option === nome);
              if (option) {
                state.respostas[perguntaId]['checkbox'][option.id] = {
                  name: option.option,
                  checked: true
                };
              }
            });
          } else if (pergunta.type === 'radio') {
            state.respostas[perguntaId]['anamnese_question_option_id'] = resp.anamnese_question_option_id;
            const selectedOption = pergunta.options.find(o => o.id === resp.anamnese_question_option_id);
            state.respostas[perguntaId]['answer'] = selectedOption?.option || '';
          } else {
            state.respostas[perguntaId]['answer'] = resp.answer;
          }
        });
      };

			function salvar() {
				try {
          /*console.log('state.avaliacaoId anamnese')
          console.log(state.avaliacaoId)
          return*/
          if(state.avaliacaoId == 0) {
            let respostas = []
            state.respostas.forEach(item => {
              let data = Object.assign({}, item)
              respostas.push(data)
            })

            context.emit('salvar', respostas, 'anamnese')
          } else {
            let respostas = []
            state.respostas.forEach(item => {
              item['student_physical_assessment_id'] = state.avaliacaoId
              let data = Object.assign({}, item)
              respostas.push(data)
            })
            store.commit('SET_SPLASH_SCREEN', true)
            anamneseRepository.AnamnesePost(respostas).then(response => {
              store.commit('SET_SPLASH_SCREEN', false)
              if (response.data.success) {
                swal({
                  title: t('anamnesis'),
                  text: t('anamnesisSavedSuccessfully'),
                  icon: "success",
                  customClass: {
                    confirmButton: "btn bg-gradient-success",
                  },
                  buttonsStyling: false,
                }).then(() => {
                  window.location.reload()
                })
              }
            }).catch((error) => {
              store.commit('SET_SPLASH_SCREEN', false)
              swal({
                icon: 'error',
                title: t('errorSavingAnamnesis'),
                text: error.message
              })
            })
          }
				} catch {
					store.commit('SET_SPLASH_SCREEN', false)
				}
			}

			return {
				state,
				salvar
			}
		},
	};
</script>

<style scoped>
.anamnese-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.anamnese-question-block {
  padding: 16px 18px;
  margin-bottom: 4px;
  border-radius: 10px;
  border-left: 4px solid #2D3A7C;
  transition: background 0.2s;
}
.anamnese-question-block:hover {
  background: #f4f6f9;
}
.anamnese-alt {
  background: #f6f8fb;
}
.anamnese-question-label {
  font-weight: 600;
  color: #344767;
  font-size: 0.92rem;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.anamnese-question-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #F7941D;
  color: #fff;
  font-weight: 700;
  font-size: 0.78rem;
  flex-shrink: 0;
}
.anamnese-answer-area {
  padding-left: 38px;
}
.anamnese-textarea {
  border: 1.5px solid #d2d6dc !important;
  border-radius: 8px !important;
  font-size: 0.9rem;
  color: #344767;
  transition: border-color 0.2s;
  resize: vertical;
}
.anamnese-textarea:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.15) !important;
}
.anamnese-input {
  border: 1.5px solid #d2d6dc !important;
  border-radius: 8px !important;
  font-size: 0.9rem;
  color: #344767;
  transition: border-color 0.2s;
}
.anamnese-input:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.15) !important;
}
.anamnese-options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.anamnese-option-item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  transition: all 0.2s;
  cursor: pointer;
}
.anamnese-option-item:hover {
  border-color: #2D3A7C;
  background: #edf0f6;
}
.anamnese-option-checked {
  border-color: #2D3A7C !important;
  background: linear-gradient(135deg, #edf0f6 0%, #e4e8f0 100%) !important;
  box-shadow: 0 0 0 2px rgba(45, 58, 124, 0.15);
}
.anamnese-check {
  width: 18px;
  height: 18px;
  border: 2px solid #2D3A7C !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.anamnese-check:checked {
  background-color: #F7941D !important;
  border-color: #F7941D !important;
}
.anamnese-option-text {
  font-size: 0.88rem;
  color: #344767;
  font-weight: 500;
}
</style>
